import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './context/store/store';
//import { SDKConnection } from "unifiedring-sdk";
import { authSDK } from "unifiedring-sdk";
import { config } from './base/constant';

//SDKConnection(config().API_URL);
authSDK.SDKConnection(config().API_URL);

const removeLoader = () => {
  const loader = document.getElementById('login_mainloader');
  if (loader) {
    loader.style.display = 'none'; 
  }
};
const AppWrapper = () => {
  useEffect(() => {
    removeLoader();
  }, []);

  return <App />;              
};

ReactDOM.render(

  <React.StrictMode>
    <Provider  store={store}>
      <AppWrapper />
     
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
